import React from 'react';
import {Text, ThemeConsumer} from 'react-native-elements';

export default function TextHeader(props: {text: string}) {
    return <ThemeConsumer>{({theme}) => {
        return <Text style={[theme.TextHeader.style]}>{props.text}</Text>
    }}</ThemeConsumer>;
}
